import React from 'react'
import { StyledDiv } from './styles'

export const Avatar = ({name}: {name: string}) => {
    name = name[0] + name[1]
  return (
    <StyledDiv>{name.toUpperCase()}</StyledDiv>
  )
}
